<template>
  <div>
    <el-drawer
      v-if="visible"
      show-close
      :visible.sync="visible"
      append-to-body
      :size="900"
      :title="$l('drawer_title_eidt_ds') || '编辑疵点'"
      :close-on-click-modal="false"
      :before-close="() => $refs.editFrom.cancel()"
    >
      <div class="drawer-main">
        <div style="color: #101010; font-size: 16px; font-weight: 500;">{{ $l('title_edit_ds') || '疵点编辑' }}</div>
        <EditFrom
          ref="editFrom"
          :dfDefinitionCode="dfDefinitionCode"
          :dfDefinitionCategoryCode="dfDefinitionCategoryCode"
          :dfDefinitionItemCode="dfDefinitionItemCode"
          @close="close"
          @reload="$emit('reload')"
        />
        <div class="d-flex justify-content-end mb-2 mt-2">
          <el-button size="small" @click="$refs.editFrom.cancel()">
            {{ $l("INDEX.btn_cancel") || "取消" }}
          </el-button>
          <el-button type="primary" size="small" @click="$refs.editFrom.save()">
            {{ $l("INDEX.btn_save") || "保存" }}
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import EditFrom from "./main.vue";
export default {
  components: { EditFrom },
  props: {
    visible: { type: Boolean, default: false },
    dfDefinitionCode: { type: String, default: "" },
    dfDefinitionCategoryCode: { type: String, default: "" },
    dfDefinitionItemCode: { type: String, default: "" },
  },
  methods: {
    close() {
      this.$emit("close");
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 32px;
}
</style>